import { render, staticRenderFns } from "./BusinessRulesTable.vue?vue&type=template&id=573f07ce&scoped=true&lang=pug&"
import script from "./BusinessRulesTable.vue?vue&type=script&lang=js&"
export * from "./BusinessRulesTable.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRulesTable.vue?vue&type=style&index=0&id=573f07ce&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f07ce",
  null
  
)

export default component.exports